import { Box, Grid, Stack, Typography } from '@mui/material';
import { hexToRGBA } from 'lib/designSystem/BarChart';
import React from 'react';

import TableCard from '../Card/TableCard';

const sizes = {
  small: {
    labelSize: '0.65rem',
    valueSize: '0.96rem',
    valueLabelSize: '0.55rem',
  },
  medium: {
    labelSize: '0.75rem',
    valueSize: '1.2rem',
    valueLabelSize: '0.625rem',
  },
};

interface StatCardProps {
  label: string;
  value: number | string;
  valueLabel: string;
  color: string;
  icon: React.ReactNode;
  size?: 'small' | 'medium';
}

const StatCard: React.FC<StatCardProps> = ({
  label,
  value,
  valueLabel,
  color,
  icon,
  size = 'medium',
}) => {
  return (
    <TableCard size="small">
      <Grid container spacing={2}>
        <Grid item xs={3}>
          <Box
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: hexToRGBA(color, 0.12),
              borderRadius: '8px',
              height: '100%',
              color,
            }}
          >
            {icon}
          </Box>
        </Grid>
        <Grid item xs={9}>
          <Typography
            variant="caption"
            color="text.primary"
            fontSize={sizes[size].labelSize}
          >
            {label}
          </Typography>
          <Stack direction="row" spacing={1}>
            <Typography
              variant="h4"
              color="text.primary"
              fontSize={sizes[size].valueSize}
            >
              {value}
            </Typography>
            <Typography
              variant="caption"
              sx={{
                color: 'text.secondary',
                fontSize: sizes[size].valueLabelSize,
                fontWeight: 500,
                alignSelf: 'end',
              }}
            >
              {valueLabel}
            </Typography>
          </Stack>
        </Grid>
      </Grid>
    </TableCard>
  );
};

export default StatCard;
